import client from '../api/client.js'

export const fetchNotificationsRequest = async (params = {}, options = {}) => {
  const response = await client.get('/notifications', {
    params,
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

export const retryNotificationRequest = async (notificationId, payload = {}, options = {}) => {
  const response = await client.post(`/notifications/retry/${notificationId}`, payload, {
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

export const fetchNotificationHistoryRequest = async (params = {}, options = {}) => {
  const response = await client.get('/notifications/history', {
    params,
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

